// Based on DateSelector component but with timezone

import TimezoneDatePicker from "./TimezoneDatePicker";
import moment from "moment-timezone";

const DateSelector = ({
  name,
  label,
  formik,
  disabledDate,
  format = "DD-MMM-yyyy",
  onChange,
  isFieldRow = false,
  timezone = Intl.DateTimeFormat().resolvedOptions().timeZone,
  defaultValue = moment.tz(timezone),
}) => {
  const changeHandler = (selectedDate) => {
    let currDate = selectedDate

    if (selectedDate === null) {
      currDate = moment().toISOString()
    }

    if (onChange) return onChange(currDate);
    formik.setFieldValue(name, moment.tz(currDate, timezone).format('YYYY-MM-DD'));
  };

  return (
    <div className={`flex mb-5 ${isFieldRow ? "flex-row" : "flex-col"}`}>
      <label
        className={`text-lg mb-3 ${isFieldRow ? "w-1/3" : ""}`}
        htmlFor={name}
      >
        {label}
      </label>
      <TimezoneDatePicker
        timezone={timezone}
        format={format}
        disabledDate={disabledDate}
        id={name}
        name={name}
        className={`border border-gray-300 text-lg p-2 rounded-lg ${isFieldRow ? "w-2/3" : ""}`}
        onChange={changeHandler}
        onBlur={formik.handleBlur}
        value={formik.values[name] ? moment.tz(formik.values[name], timezone) : defaultValue}
      />
      {formik.touched[name] && formik.errors[name] && (
        <div className="text-red-600">{formik.errors[name]}</div>
      )}
    </div>
  );
};

export default DateSelector;
